export const smallUp = 'screen and (min-width: 576px)';
export const mediumUp = 'screen and (min-width: 760px)';
export const largeUp = 'screen and (min-width: 1024px)';
export const extraLargeUp = 'screen and (min-width: 1366px)';
export const fullHdUp = 'screen and (min-width: 1920px)';
